import Spinner from "../../../../components/Spinner.jsx";
import {useTranslation} from "react-i18next";
import {useErrorTranslation} from "../../../../api/utilities/translateErrorMessage.js";
import {useContext, useEffect, useState} from "react";
import {GlobalContext} from "../../../../utils/context/GlobalContextProvider.jsx";
import useDownloadState from "../../../../api/utilities/useDownloadState.js";
import LoadingComponent from "../../../../components/LoadingComponent.jsx";
import {ProjectIntegrationsApi} from "../../../../api/authority/generated/index";
import microsoftLogo from "../../../../images/brands/microsoft.svg";
import OAuthAdAccountsFormLayout from "../OAuthAdAccountsFormLayout.jsx";
import {IntegrationConnectButton} from "../IntegrationDetailUi.jsx";

export default function MicrosoftIntegrationForm({project, projectIntegration, refreshOAuthResources}) {

    let {t} = useTranslation();
    let {et} = useErrorTranslation();

    let adAccountDefaultValues = [];
    let adAccountOptions = [];

    for (let adAccount of projectIntegration?.microsoftIntegrationCustomers ?? []) {
        adAccountOptions.push({
            value: adAccount.remoteId,
            label: '[' + adAccount.remoteNumber + '] ' + adAccount.name
        });

        if (adAccount.enabled) {
            adAccountDefaultValues.push({
                value: adAccount.remoteId,
                label: '[' + adAccount.remoteNumber + '] ' + adAccount.name
            });
        }
    }

    let [selectedAdAccounts, setSelectedAdAccounts] = useState(adAccountDefaultValues);

    const {context, getAuthorityConfiguration, resetCurrentUserProjects} = useContext(GlobalContext);

    let redirectToLogin = () => {
        let oAuthUrl = new URL(import.meta.env.VITE_AUTHORITY_URL);
        oAuthUrl.pathname = '/api/v1/project/integrations/microsoft';

        let query = new URLSearchParams({
            authorization: context.currentIdentity?.token,
            projectId: project.id,
        });

        if (projectIntegration?.id) {
            query.set('integrationId', projectIntegration.id);
        }

        oAuthUrl.search = query.toString();

        window.location.href = oAuthUrl.toString();
    };

    let [saving, setSaving] = useState(false);

    let saveAdAccounts = () => {
        console.log('SAVING!');
        let adAccountIds = [];

        for (let adAccountOption of selectedAdAccounts) {
            adAccountIds.push(adAccountOption.value);
        }

        setSaving(true);
        new ProjectIntegrationsApi(getAuthorityConfiguration())
            .chooseMicrosoftAdAccounts({
                projectId: project.id,
                integrationId: projectIntegration.id,
                requestBody: adAccountIds
            })
            .then(() => {
                resetCurrentUserProjects();
            })
            .finally(() => setSaving(false))
    };

    const refreshAdAccounts = () => {
        setSaving(true);
        Promise.resolve(refreshOAuthResources())
            .finally(() => setSaving(false));
    };

    useEffect(() => {
        if (!projectIntegration) {
            setTimeout(
                () => redirectToLogin(),
                600,
            )
        }
    }, []);

    if (!projectIntegration) {
        return (
            <div>
                <Spinner size={'spinner-large'} className={'mx-auto'}/>
                <p className={'text-center mt-4'}>{t('redirecting')}...</p>
            </div>
        );
    }

    let reconnectRequired = !projectIntegration.authorizationSuccessful || (projectIntegration.errors ?? []).length > 0;

    // noinspection JSValidateTypes
    return (
        <LoadingComponent loading={saving || selectedAdAccounts === null}>
            <OAuthAdAccountsFormLayout
                providerName={'Microsoft Advertising'}
                reconnectRequired={reconnectRequired}
                connectButton={<IntegrationConnectButton logo={microsoftLogo} logoAlt={'Microsoft'} label={reconnectRequired ? 'Připojit' : 'Obnovit připojení'} onClick={redirectToLogin}/>}
                accountSelectName={'microsoft-ad-accounts'}
                selectedAccounts={selectedAdAccounts}
                accountOptions={adAccountOptions}
                onAccountsChange={setSelectedAdAccounts}
                onRefresh={refreshAdAccounts}
                onSave={saveAdAccounts}
            />
        </LoadingComponent>
    );
}
